module.exports = __webpack_public_path__ + "img/pg-yuanfactory.bb17a643.jpg";